import { createAction } from 'redux-actions';
import { batchActions } from 'redux-batched-actions';
import authService from "../../domain/services/AuthService";

import { setGeneratingLoaderVisibility } from "../../../layout/store/actions";

const namespace = 'AUTH_ANONYMOUSLY';


export const anonymouslySignInRequest = createAction(`${namespace}/ANONYMOUS_SIGN_IN_REQUEST`);
export const anonymouslySignInSuccess = createAction(`${namespace}/ANONYMOUS_SIGN_IN_SUCCESS`);
export const anonymouslySignInFailed = createAction(`${namespace}/ANONYMOUS_SIGN_IN_FAILED`);

export function loginAnonymously() {
  return (dispatch, getState) => {

    dispatch(anonymouslySignInRequest());

    authService.signInAnonymously()
      .then((response) => {
        dispatch(anonymouslySignInSuccess(response));
      })
      .catch((error) => {
        dispatch(batchActions([
          anonymouslySignInFailed(error),
          setGeneratingLoaderVisibility(false)
        ]));
      })
  };
}


// WEBPACK FOOTER //
// ./src/app/modules/auth/store/auth-anonymously/actions.ts